export default "__VITE_ASSET__CkOf_dtI__"